<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.relatedLinks") }}</h4>
    </div>
    <div class="commTop_btn_wrap p-2" style="text-align: right">
      <router-link
        to="/management/support/relatedlink/form"
        class="btn btn-primary btn-md m-2"
        >{{ $t("common.add") }}</router-link
      >
      <button type="button" @click="showLinkModal" class="btn btn-secondary btn-md">
        {{ $t("common.changeOrder") }}
      </button>
    </div>
    <table class="list_tbl">
      <thead>
        <tr>
          <th class="mobile_row">{{ $t("management.siteName") }}</th>
          <th class="mobile_h">{{ $t("management.url") }}</th>
          <th class="mobile_h">{{ $t("common.description") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="linkList.length != 0">
        <tr v-for="(link, index) in linkList" :key="index">
          <td class="text-left">
            <router-link
              :to="{ name: 'mgmtRelatedForm', params: { linkId: link.linkId } }"
              >{{ link.linkName }}</router-link
            >
          </td>
          <td class="text-left">
            <router-link
              :to="{ name: 'mgmtRelatedForm', params: { linkId: link.linkId } }"
              >{{ link.linkUrl }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{ name: 'mgmtRelatedForm', params: { linkId: link.linkId } }"
              >{{ link.description }}</router-link
            >
          </td>
          <td>
            <button
              type="button"
              @click="deleteRelatedLink(link.linkId)"
              class="btn btn-secondary btn-sm"
            >
              {{ $t("common.delete") }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <CommonModal id="relatedLinkModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("common.changeOrder") }}</h3>
      </template>
      <template slot="body">
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row w-25">{{ $t("management.siteName") }}</th>
              <th class="mobile_h w-25">{{ $t("management.url") }}</th>
            </tr>
          </thead>
          <draggable v-model="linkList" tag="tbody">
            <tr v-for="(link, index) in linkList" :key="index">
              <td class="w-25">{{ link.linkName }}</td>
              <td class="w-25">{{ link.linkUrl }}</td>
            </tr>
          </draggable>
        </table>
      </template>
      <template slot="footer">
        <button type="button" @click="saveNewSort" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import {
  getRelatedLinkList,
  deleteRelatedLink,
  saveNewRelatedLinkSort,
} from "@/api/relatedlink";
import CommonModal from "@/components/modal/CommonModal";
import draggable from "vuedraggable";
export default {
  components: {
    CommonModal,
    draggable,
  },
  data() {
    return {
      linkList: [],
      link: {},
      showModal: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getRelatedLinkList();
        this.linkList = data.linkList;
      } catch (error) {
        console.log(error);
      }
    },
    showLinkModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    //새로운 순서 저장
    async saveNewSort() {
      this.conformYN = confirm(this.$t("alert.save"));
      if (this.conformYN) {
        try {
          const { data } = await saveNewRelatedLinkSort(this.linkList);
          if (data.status) {
            alert(this.$t("alert.changedSuccessfully"));
            this.fetchData();
            this.showModal = false;
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
    // 삭제
    async deleteRelatedLink(linkId) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          this.link.linkId = linkId;
          const { data } = await deleteRelatedLink(this.link);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.fetchData();
          } else {
            this.link.linkId = "";
            alert(this.$t("alert.ErrorPleasecontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped></style>
